/**
 * The Z5 tool panel and Z6 rail, as rules (docs/audits/PILOT-QUOTES-SHELL.md §2.1-§2.2, S5).
 * Pure: no React, no DOM.
 *
 * G0: the numbers and the push/sheet math live in layout/splitGeometry.js, shared with the
 * generic split; this file re-exports them (its callers and tests are unchanged) and keeps the
 * one rule that is the rail's alone, the order.
 *
 * ORDER. toolRail (the module's document) is the ordered list of the tools SHOWN. Nothing
 * stored: every tool, in registry order. An id not in it is hidden; an unknown or repeated id
 * is ignored; [] means no tools, so no rail and no Tools button.
 */
export {
  TOOL_COLUMN_DEFAULT,
  TOOL_COLUMN_MIN,
  TOOL_COLUMN_MAX,
  TOOL_SHEET_WIDTH,
  TOOL_RAIL_WIDTH,
  TOOL_RESIZE_STEP,
  clampToolWidth,
  toolColumnRoom,
  toolPanelLayout
} from '../splitGeometry';

/** The tools to show, in the user's order (see ORDER above). */
export function orderedTools(tools, toolRail) {
  if (!Array.isArray(toolRail)) return tools.slice();
  const byId = new Map(tools.map((t) => [t.id, t]));
  const seen = new Set();
  const out = [];
  for (const id of toolRail) {
    if (byId.has(id) && !seen.has(id)) {
      seen.add(id);
      out.push(byId.get(id));
    }
  }
  return out;
}
